export const validation = {
  name: 'Location name is required',
  countryId: 'Country is required',
  locationFor: 'Location for is required',
  pullPermitCost: 'Pull permit cost is required',
};
